<template>
  <DefaultField :field="field" :errors="errors" full-width-content :show-help-text="showHelpText">
    <template #label>
      <div></div>  
    </template>
    <template #field>
        <div class="w-full flex flex-wrap items-center gap-2" >
            <Link v-for="button in currentField.buttons" :key="button.name" :href="button.url" class="w-64 h-10 rounded-2xl bg-blue-500 dark:bg-primary-400 text-white flex items-center justify-center">
                {{ button.name }}
            </Link>
        </div>
    </template>
  </DefaultField>
</template>

<script>
import { DependentFormField, HandlesValidationErrors } from '@/mixins'

export default {
    mixins: [DependentFormField, HandlesValidationErrors],

    props: ['resourceName', 'resourceId', 'field'],


    computed: {
        buttons() {
            return this.currentField.buttons;
        },
    },
}
</script>